import './attachmentViewDownloadComponent.scss'
import React, {useCallback, useState} from 'react';
import ButtonComponent from '../button/ButtonComponent';
import DialogComponent from "../../dialog/dialogComponent";
import FilePreviewerComponent from "../../file-previewer/filePreviewerComponent";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import PdfPreviewComponent from "../../pdf-preview/pdfPreviewComponent";
import ChipComponent from '../../chip/ChipComponent';
import {CommonService} from "../../../services";

interface AttachmentViewDownloadComponentProps {
    attachment: any;
    showDownloadOption?: boolean;
    showDeleteOption?: boolean;
    attachmentTitle?: string;
    onClick?: Function
}

const AttachmentViewDownloadComponent = (props: AttachmentViewDownloadComponentProps) => {
        const {attachment, attachmentTitle, onClick, showDeleteOption, showDownloadOption} = props
        const [showAttachmentPreviewDialog, setShowAttachmentPreviewDialog] = useState<boolean>(false);
        const [currentAttachmentFile, setCurrentAttachmentFile] = useState<any | undefined>(undefined);
        const [attachmentType, setAttachmentType] = useState<string>("");

        const handleAttachmentPreviewOpen = useCallback((attachment: any) => {
            setShowAttachmentPreviewDialog(true);
            setCurrentAttachmentFile(attachment);
            if (attachment.type === 'application/pdf') {
                setAttachmentType('pdf')
            } else {
                setAttachmentType('image')
            }
        }, []);

        return (
            <div className="attachment-view-download-wrapper">
                {showDeleteOption ?
                    <ChipComponent
                        className="attachment-chip-item"
                        icon={<AttachFileIcon/>}
                        onDelete={() => {
                            if (onClick) {
                                onClick(attachment?.id);
                            }
                        }}
                        onClick={
                            () => handleAttachmentPreviewOpen(attachment)
                        }
                            label={attachmentTitle ? attachmentTitle : attachment.fileName}
                    /> :
                    <ChipComponent
                        className="attachment-chip-item"
                        icon={<AttachFileIcon/>}
                        onClick={
                            () => handleAttachmentPreviewOpen(attachment)
                        }
                        label={attachmentTitle ? attachmentTitle : attachment.fileName}
                    />
                }
                <DialogComponent
                    maxWidth={'md'}
                    open={showAttachmentPreviewDialog}
                    className={"attachment-preview-dialog"}
                    onClose={() => setShowAttachmentPreviewDialog(false)}>
                    <div className="attachment-preview-dialog-header">
                        <div className="attachment-preview-dialog-title">
                            Attachment Preview
                        </div>
                    </div>
                    <div className="attachment-preview-dialog-body">
                        {attachment?.mimeType === 'application/pdf' ?
                            <PdfPreviewComponent
                                attachmentUrl={currentAttachmentFile?.url}
                                width="850"
                                height="500"
                                isFile={false}
                            />
                            :
                            <FilePreviewerComponent
                                attachmentUrl={currentAttachmentFile?.url}
                            />
                        }
                    </div>
                    <div className="attachment-preview-dialog-footer mrg-top-10">
                        {
                            showDownloadOption ? <>
                                <ButtonComponent variant={"contained"}
                                                 fullWidth={true}
                                                 handleClick={() => {
                                                     setShowAttachmentPreviewDialog(false)
                                                 }}>
                                    Close
                                </ButtonComponent>
                                <ButtonComponent variant={"outlined"}
                                                 fullWidth={true}
                                                 className={"mrg-left-10"}
                                                 handleClick={() => {
                                                     CommonService.downloadFile(currentAttachmentFile?.url, currentAttachmentFile?.title, attachmentType)
                                                 }}>
                                    Download
                                </ButtonComponent>
                            </> : <ButtonComponent
                                variant={"contained"}
                                className="width-10"
                                type="button"
                                color={"primary"}
                                fullWidth={true}
                                handleClick={() => {
                                    setShowAttachmentPreviewDialog(false)
                                }}>
                                Close
                            </ButtonComponent>
                        }
                    </div>
                </DialogComponent>
            </div>
        )
    }
;
export default AttachmentViewDownloadComponent;
